var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ve-table',{staticStyle:{"width":"100%"},attrs:{"scroll-width":_vm.scrollWidth,"columns":_vm.columns,"table-data":_vm.tableData,"row-key-field-name":"keyName","rowStyleOption":{ stripe: true }}})
}
var staticRenderFns = []

export { render, staticRenderFns }